import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ensureSession, recordEvent } from "@/lib/analytics";

/**
 * Mounts once near the router. On every route change:
 *  1) Ensures an `analytics_sessions` row exists / is refreshed.
 *  2) Records a `page_view` event into `analytics_events`.
 *
 * Failures are swallowed inside the analytics layer so this component is
 * always safe to mount and never blocks navigation.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    void ensureSession();
    void recordEvent("page_view", {
      metadata: {
        path: location.pathname,
        search: location.search,
        title: typeof document !== "undefined" ? document.title : undefined,
      },
    });
  }, [location.pathname, location.search]);

  return null;
}
